import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row'
    }
  },
  autocompleteLabel: {
    borderRadius: '0px'
  },
  locationLabel: {
    textTransform: 'uppercase'
  },
  locationRoot: {
    marginBottom: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 225,
      marginRight: theme.spacing(4),
      marginBottom: 0
    },
    '&:hover': {
      '& > span > svg': {
        fill: theme.palette.common.white
      }
    }
  },
  autocompleteInputRoot: {
    borderRadius: '0px',
    paddingRight: 0
  },
  autocompleteInputLabel: {
    padding: 0,
    marginLeft: 0,
    color: theme.palette.common.darkGray,
    top: -7
  },
  autocompleteRoot: {
    display: 'flex',
    marginLeft: 'auto',
    width: '100%'
  },
  endAdornment: {
    right: `0 !important`,
    width: '46px',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  adornedEnd: {
    width: '46px',
    height: '100%',
    display: 'flex',
    backgroundColor: theme.palette.common.adornedEnd,
    justifyContent: 'center',
    alignItems: 'center'
  },
  input: {
    padding: theme.spacing(1.75, 0)
  },
  root: {
    padding: `${theme.spacing(0)} !important`,
    borderRadius: '0px',
    '& $input': {
      padding: `${theme.spacing(1.75, 0, 1.75, 2)} !important`,
      borderRadius: '0px'
    }
  },
  notchedOutline: {
    top: 0,
    '& legend': {
      display: 'none'
    },
  },
  labelSearchByPlace: {
    fontSize: 14,
    [theme.breakpoints.up('md')]: {
      fontSize: 16
    }
  }
}));
